import Home from '@/views/Home.vue'

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Wybieram Dziecko - Akademia Przyszłości'
    }
  },
  {
    path: '/nowa-edycja',
    redirect: '/',
    name: 'HomeRetention'
  }
]
